module.exports = __webpack_public_path__ + "img/vertical_1_1_8017.b92c8d5c.png";